import { oneOf } from 'prop-types';
import { getUserData } from '../../api/auth';
import IntlMessages from '../../layout/components/lang/IntlMessages';
import { NavLink } from 'react-router-dom';

export const assets = [
  {
    header: <IntlMessages id='assets' />,
    oneOf: ['asset:read', 'dashboardRead'],
  },
  {
    id: 'assets-dashboard',
    title: <IntlMessages id='dashboard' />,
    navLink: '/apps/cockpit/inventory-dashboard',
    requires: 'dashboard:read',
  },
  {
    id: 'cockpit-assets',
    title: <IntlMessages id='assets' />,
    navLink: '/apps/cockpit/inventory',
    requires: 'asset:read',
  },
];

export const customers = [
  { header: <IntlMessages id='customers' />, oneOf: ['customer:read'] },
  {
    id: 'cockpit-customers',
    title: <IntlMessages id='customers' />,
    navLink: '/apps/cockpit/customers',
    requires: 'customer:read',
  },
];

export const settings = [
  {
    header: <IntlMessages id='settings' />,
    oneOf: ['settings:read', 'settings:update'],
  },

  {
    id: 'cockpit-settings-tags',
    title: <IntlMessages id='tags' />,
    navLink: '/apps/cockpit/settings/tags',
    requires: ['settings:read'],
  },

  {
    id: 'cockpit-settings-states',
    title: <IntlMessages id='states' />,
    navLink: '/apps/cockpit/settings/states',
    requires: ['settings:read'],
  },
];

const cockpit = [
  {
    header: <IntlMessages id='rents' />,
    oneOf: ['rent:read'],
  },
  {
    id: 'cockpit-rents',
    title: <IntlMessages id='rents' />,
    navLink: '/apps/cockpit/rents',
    requires: 'rent:read',
  },
];

export const booking = [
  {
    header: 'Booking',
    oneOf: [
      'booking:read',
      'booking:update',
      'booking-settings:update',
      'booking-settings:read',
      'self-booking:read',
      'self-booking:update',
    ],
  },
  {
    id: 'final-customers',
    title: 'Clientes finais',
    requires: 'booking-settings:read',
    navLink: '/apps/cockpit/final-customers',
  },
  {
    id: 'centers',
    title: 'Centros',
    requires: 'booking-settings:read',
    navLink: '/apps/cockpit/centers',
  },
  {
    id: 'colaborators',
    title: 'Colaboradores',
    requires: 'booking-settings:read',
    navLink: '/apps/cockpit/colaborators',
  },
  {
    id: 'services',
    title: 'Serviços',
    requires: 'booking-settings:read',
    navLink: '/apps/cockpit/services',
  },
  {
    id: 'bookings',
    title: 'Marcações',
    navLink: '/apps/cockpit/bookings',
    requires: 'booking:read',
  },
];
export const maintenances = [
  {
    header: 'Manutenções',
    oneOf: ['maintenance:read'],
  },
  {
    id: 'cockpit-maintenances',
    title: 'Manutenções',
    navLink: '/apps/cockpit/maintenances',
    requires: 'maintenance:read',
  },
];

export default cockpit;
